import { OffHoursRecommendationsChartData } from "@/components/pages/recommendations/components/off-hours-recommendations/utils/types/types";

export const generateYAxisCpuAndDbTicks = (
  data: OffHoursRecommendationsChartData[],
) => {
  const { cpu, dbConnections } = generateMaxValues(data);

  const yAxisCpuTicks = [];
  const maxCpu = Math.max(cpu, 100);
  for (let i = 0; i < maxCpu + 10; i += 10) {
    yAxisCpuTicks.push(i);
  }

  const yAxisDbTicks = [];
  const maxDb = Math.max(dbConnections, 3);
  for (let i = 0; i < maxDb + 5; i += 1) {
    yAxisDbTicks.push(i);
  }

  return { yAxisCpuTicks, yAxisDbTicks };
};

const generateMaxValues = (data: OffHoursRecommendationsChartData[]) => {
  return data.reduce(
    (max, val) => {
      return {
        cpu: Math.max(val.cpu || 0, max.cpu),
        dbConnections: Math.max(
          val.database_connections || 0,
          max.dbConnections,
        ),
      };
    },
    { cpu: 0, dbConnections: 0 },
  );
};
